import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { B2bUnitEffects } from '@b2b/features/b2b-unit/core/store/b2b-unit.effect';
import { b2bUnitReducer } from '@b2b/features/b2b-unit/core/store/b2b-unit.reducer';
import { B2B_UNIT_FEATURE } from '@b2b/features/b2b-unit/core/store/b2b-unit.states';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(B2B_UNIT_FEATURE, b2bUnitReducer),
    EffectsModule.forFeature([B2bUnitEffects]),
  ],
})
export class B2bUnitStoreModule {}
